import {QuizSession} from '@cp/model';
import {useMemo} from 'react';
import subscribeQuizSessionCollectionActive from '../../api/quizSession/subscribeQuizSessionCollectionActive';
import {useFunctionSubscribe} from '../helper/function/useFunctionSubscribe';
import {useAuth} from '../users/useAuth';

const ACTIVE_SESSIONS_LIMIT = 10;

export default function useListUserActiveSession(moduleId?: string) {
  const user = useAuth();
  const uid = user?.id ?? '';

  const subscribe = useMemo(
    () => (onData: (data: QuizSession[]) => void, onError: (err: Error) => void) =>
      subscribeQuizSessionCollectionActive(uid, onData, onError, ACTIVE_SESSIONS_LIMIT),
    [uid],
  );

  const {
    data: activeSessions = [],
    loading,
    error,
  } = useFunctionSubscribe<QuizSession[]>(subscribe, {
    skip: !uid,
    deps: [uid],
  });

  const moduleSessions = useMemo(
    () => (moduleId ? activeSessions.filter((s) => s.moduleId === moduleId) : activeSessions),
    [activeSessions, moduleId],
  );

  const hasActiveSession = moduleSessions.length > 0;
  const mostRecentSession = moduleSessions[0];

  return {
    activeSessions: moduleSessions,
    hasActiveSession,
    mostRecentSession,
    loading,
    error,
    refetch: () => Promise.resolve(),
  };
}
